import { gql } from "@apollo/client";

const schema = {
  list: {
    name: "users",
    serviceName: "unitadmin",
    query: gql`
      query users(
        $ids: [String]
        $national_codes: [String]
        $emails: [String]
        $tellphones: [String]
        $cellphones: [String]
        $status_ids: [String]
        $unit_ids: [String]
        $username: String
        $firstname: String
        $lastname: String
        $gender: Int # 0 , 1
        $is_active: Int # 0 , 1
        $birth_date: String
        $skin_color: String
        $type_ids: [String]
        $has_role_name: String # کاربرانی که این نقش را دارند
        $has_permission_name: String # کاربرانی که این مجوز را دارند
        $lab_ids: [String]
        $device_zones: [String] # ios,android,a_device,no_device
        $user_category_ids: [String] #کاربرانی که به این مجموعه‌ها تعلق دارند
        $user_section: String # CUSTOMER,OPERATOR,CATEGORY
        $page: Int
        $limit: Int
        $orderBy_field: String # >created_at
        $orderBy_direction: String # ASC , >DESC
      ) {
        users(
          ids: $ids
          national_codes: $national_codes
          emails: $emails
          tellphones: $tellphones
          cellphones: $cellphones
          status_ids: $status_ids
          unit_ids: $unit_ids
          username: $username
          firstname: $firstname
          lastname: $lastname
          gender: $gender
          is_active: $is_active
          birth_date: $birth_date
          skin_color: $skin_color
          type_ids: $type_ids
          has_role_name: $has_role_name
          has_permission_name: $has_permission_name
          lab_ids: $lab_ids
          device_zones: $device_zones
          user_category_ids: $user_category_ids
          user_section: $user_section
          page: $page
          limit: $limit
          orderBy_field: $orderBy_field
          orderBy_direction: $orderBy_direction
        ) {
          data {
            id
            firstname
            lastname
            username
            media {
              id
              full_url
            }
          }
          total
        }
      }
    `,
  },
  assignment: {
    name: "users",
    serviceName: "unitadmin",
    query: gql`
      query users($ids: [String]) {
        users(ids: $ids) {
          data {
            id
            lastname
            firstname
          }
        }
      }
    `,
  },
};

export default schema;
